import { authenticatedAxios } from "lib/actions/fetcher";
import { endpointsSpeckle } from "./endpointsSpeckle";
import { SpeckleProjectModel } from "../../SpeckleImportWizard/types/SpeckleProjectModel";

export function speckleCreateProject(
  connectedAccountId: number,
  workspaceId: string,
  model: Omit<SpeckleProjectModel, "id">,
) {
  return authenticatedAxios
    .request<SpeckleProjectModel>({
      ...endpointsSpeckle.createProject(connectedAccountId, workspaceId),
      data: model,
    })
    .then((resp) => resp.data);
}
